import { mutate } from 'swr';
// logic
import { useHistory } from 'react-router-dom';
import ticketService from 'modules/emergencies/ticketService';
// components
import '../ui/emergencyPopup.css';
import { Modal } from 'react-async-popup';
import { MoveToTMSModal } from './moveToTMSModal';

const useMoveToTMSModal = (ticket) => {
  const history = useHistory();
  const moveToTMSModalProps = { ticket };
  const moveToTMSModal = async () => {
    const { show } = await Modal.new({
      content: <MoveToTMSModal moveToTMSModalProps={moveToTMSModalProps} />,
      footer: null,
    });
    const result = await show();
    return result;
  };

  const ticketId = ticket?.id;

  const openMoveToTMSModal = async () => {
    const result = await moveToTMSModal();
    if (result) {
      const orderIdDTO = {
        agency_ids: [result.selectedAgencyId],
      };
      try {
        await ticketService.callBackend.moveTicketToTMS({ id: ticketId, orderIdDTO });
        // we are mutating the tickets cache so it will reload automatically
        mutate((key) => {
          return typeof key === 'string' && key.startsWith('tickets');
        });
      } catch (error) {}

      history.push('/emergencies');
    }
  };

  return {
    openMoveToTMSModal,
  };
};

export default useMoveToTMSModal;
